<ng-template #defaultItemContentTpl let-item="item">
  <ng-container *ngIf="!!item.link; else itemContentTpl">
    <a [href]="item.link">
      <ng-template [ngTemplateOutlet]="itemContentTpl"></ng-template>
    </a>
  </ng-container>

  <ng-template #itemContentTpl>
    <div *ngIf="!!item.icon" class="icon">
      <app-iconic [icon]="item.icon"></app-iconic>
    </div>

    <div class="text" *ngIf="!!(item.text && textEnabled)">
      {{ item.text }}
    </div>
  </ng-template>
</ng-template>

<ng-template
  #itemTpl
  let-parentItem="parentItem"
  let-items="items"
  let-item="item"
  let-index="index"
  let-level="level"
>
  <div
    *ngIf="!(item.visible === false)"
    class="tree-item {{ 'item-level-' + level }}"
    style="--tree-item-level: {{ level }}"
    [ngClass]="{
      'item-has-icon': !!item.icon,
      'item-has-text': !!(item.text && textEnabled),
      'item-has-items': !!item.items?.length,
      'opened-indicator-at-left': !!openedIndicatorAtLeft,
      'text-ellipsis-mode': !!textEllipsisMode,
      'state-disabled': !!item.disabled,
      'state-selected': !!item.selected,
      'state-opened': !!item.opened
    }"
  >
    <div
      #itemContentEl
      class="tree-item-content"
      [title]="
        !hintEnabled || (tooltipEnabled && !!item.tooltip) ? '' : item.text
      "
      (click)="onItemClickInternal($event, item, parentItem)"
    >
      <div class="tree-item-content-wrapper">
        <ng-template
          [ngTemplateOutlet]="
            item.itemTemplate ??
            treeItemTpl?.templateRef ??
            defaultItemContentTpl
          "
          [ngTemplateOutletContext]="{parentItem, items, item, index, level}"
        ></ng-template>
      </div>

      <div
        class="opened-indicator"
        *ngIf="!!(openedIndicatorEnabled && shouldShowIndicator(item))"
      >
        <app-iconic
          class="opened-indicator-icon"
          icon="assets/icons/chevron-down.svg"
        ></app-iconic>
      </div>
    </div>

    <app-tooltip
      *ngIf="tooltipEnabled && !!item.tooltip"
      [target]="itemContentEl"
      verticalAlignment="center"
      horizontalAlignment="right"
    >
      {{ item.tooltip }}
    </app-tooltip>

    <ng-container *appDeferRendering="!!(!deferRendering || item.opened)">
      <div class="tree-sub-list" *ngIf="shouldShowItems(item)">
        <ng-container
          [ngTemplateOutlet]="item.subListTemplate ?? listItemsTpl"
          [ngTemplateOutletContext]="{
            item,
            items: item.items,
            level: level + 1
          }"
        ></ng-container>
      </div>
    </ng-container>
  </div>
</ng-template>

<ng-template
  #listItemsTpl
  let-parentItem="item"
  let-items="items"
  let-level="level"
>
  <app-list [items]="items" [scrollable]="!!scrollable" [keyExpr]="keyExpr">
    <ng-template listItem let-item="item" let-index="index">
      <ng-container
        [ngTemplateOutlet]="itemTpl"
        [ngTemplateOutletContext]="{parentItem, items, item, index, level}"
      ></ng-container>
    </ng-template>
  </app-list>
</ng-template>

<ng-container
  [ngTemplateOutlet]="listItemsTpl"
  [ngTemplateOutletContext]="{items, level: 1}"
></ng-container>
